import Axios from "axios";
import HTTP_STATUS from "Constants/app-constants";
import APP_CONSTANTS from "../constants/app-constants";
import { removeItem, getItem } from "../services/storage-service";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

axios.interceptors.request.use((request) => {
  request.headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: getItem(APP_CONSTANTS.ACCESS_TOKEN) || ""
  }

  return request
})

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    // LOGOUT IN CASE OF UNAUTHORIZE
    if (error?.response?.data?.code === HTTP_STATUS.UNAUTHORIZE) {
      axios.defaults.headers.common['Authorization'] = null;
      removeItem(APP_CONSTANTS.ACCESS_TOKEN);
      location.reload();
    }

    console.log("An error occurred in API Client");

    return error?.response;
  }
);

export default axios;
